module.exports = __webpack_public_path__ + "img/upx2.ccc34661.svg";